import { observer } from "mobx-react-lite";
import type { PropsWithChildren } from "react";

type ShortcutBoxProps = {
   className?: string;
};

const ShortcutBox = ({ className = "", children }: PropsWithChildren<ShortcutBoxProps>) => {
   return <div className={`m-1 shrink bg-surface-default p-3 ${className}`}>{children}</div>;
};

export default observer(ShortcutBox);
